import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// Asegúrate de que estas rutas coincidan con la capitalización y la extensión de tus archivos locales.
import Login from '../pages/Login';
import MedicosView from '../pages/Dashboard';
import Chat from '../pages/Chat';
import Profile from '../pages/Profile';
import Landing from '../pages/Landing';
import PrivateRoute from './PrivateRoute'; 

import AdminLayout from '../components/AdminLayout';

import Pacientes from '../pages/Pacientes';
import Citas from '../pages/Citas';
import Recetas from '../pages/Recetas';
import Laboratorios from '../pages/Laboratorios';
import Reportes from '../pages/Reportes';
import Consultorios from '../pages/Consultorios';

import Roles from '../pages/Roles';
import Clinicas from '../pages/Clinicas';
import Usuarios from '../pages/Usuarios';

import ExpedientesView from '../pages/ExpedientesView'; 

// *** ÚNICO CAMBIO 1/2: IMPORTACIÓN DE MEDICAMENTOS ***
import Medicamentos from '../pages/Medicamentos'; 

export default function AppRoutes() {
  return (
    <Router>
      <Routes>

        {/* Rutas Públicas */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/landing" element={<Landing />} />

        {/* Rutas Protegidas (Requieren autenticación) */}
        <Route 
          path="/" 
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        >
          {/* Rutas Privadas Anidadas bajo el layout de Admin */}
          
          {/* === REDIRECCIÓN SOLICITADA === */}
          {/* Esta es la ruta por defecto (index) que se ejecuta al iniciar sesión. */}
          {/* Usamos ruta relativa "reportes" para anidación. */}
          <Route index element={<Navigate to="reportes" replace />} />
          {/* ============================== */}
          
          <Route path="reportes" element={<Reportes />} />
          <Route path="roles" element={<Roles />} />
          <Route path="clinicas" element={<Clinicas />} />
          <Route path="usuarios" element={<Usuarios />} />
          <Route path="medicos" element={<MedicosView />} /> 
          <Route path="consultorios" element={<Consultorios />} />
          <Route path="pacientes" element={<Pacientes />} />
          <Route path="citas" element={<Citas />} />
          <Route path="recetas" element={<Recetas />} />
          
          {/* *** ÚNICO CAMBIO 2/2: RUTA DE MEDICAMENTOS AÑADIDA DESPUÉS DE RECETAS *** */}
          <Route path="medicamentos" element={<Medicamentos />} />

          <Route path="laboratorios" element={<Laboratorios />} />
          <Route path="chat" element={<Chat />} />
          <Route path="perfil" element={<Profile />} />
          <Route path="expedientes" element={<ExpedientesView />} />

        </Route>

      </Routes>
    </Router>
  );
}